import React from 'react'
import DataTable from '../../DataTable/DataTable'
import ReservationCardActions from '../actions/ReservationCardActions';

import clsx from "clsx"

export default class ReservationCardServiceLogs extends React.Component {
    constructor(props) {
        super(props)
        this.updateServiceRequestCount = this.updateServiceRequestCount.bind(this)
    }

    render() {
        var tabClasses = clsx({
            'active': this.props.active_tab == 'service-logs',
            'tab-pane': true
        });

        return (
            <div className={tabClasses} id='service-logs'>
                <DataTable endpoint={this.props.reservation_service_logs_path} updateNoteCount={this.updateServiceRequestCount} date_format={this.props.date_format} time_format={this.props.time_format} />
            </div>
        )
    }

    updateServiceRequestCount(count) {
      ReservationCardActions.updateServiceRequestCount(count)
    };
};
